import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystem, WithPagination } from "@classview/shared-types";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

export const getAdminRoomSystems = async ({
  pageSize = 10,
  pageIndex = 0,
  search,
}: {
  pageSize?: number;
  pageIndex?: number;
  search?: string;
}): Promise<WithPagination<PublicRoomSystem>> => {
  const offset = pageIndex * pageSize;
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";

  const response = await axiosClient.get(
    `/room-systems?limit=${pageSize}&offset=${offset}${searchParam}`,
  );
  return response.data;
};

export function getAdminRoomSystemsQueryKey({
  pageSize,
  pageIndex,
  search,
}: {
  pageSize?: string;
  pageIndex?: string;
  search?: string;
}) {
  return ["room-systems", "admin", pageSize, pageIndex, search];
}

export function useGetAdminRoomSystems(
  {
    pageSize,
    pageIndex,
    search,
  }: {
    pageSize?: number;
    pageIndex?: number;
    search?: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<WithPagination<PublicRoomSystem>, HttpError>
  >,
) {
  return useQuery({
    queryKey: getAdminRoomSystemsQueryKey({
      pageSize: `pagesize-${pageSize}`,
      pageIndex: `pageindex-${pageIndex}`,
      search: `search-${search || "no-search"}`,
    }),
    queryFn: () => getAdminRoomSystems({ pageSize, pageIndex, search }),
    placeholderData: keepPreviousData,

    ...queryOptions,
  });
}
